<div class="flex flex-column mt-4">
  <ng-container
    *ngTemplateOutlet="
      summaryRow;
      context: {label: 'Net Amount', value: netAmount | currency: 'USD'}
    "
  ></ng-container>

  @if (showTax) {
    <ng-container
      *ngTemplateOutlet="summaryRow; context: {label: 'Tax rate', value: taxRate + '%'}"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        summaryRow;
        context: {label: 'Tax fee', value: taxAmount | currency: 'USD'}
      "
    ></ng-container>
  }

  @if (showCCFee) {
    <ng-container
      *ngTemplateOutlet="
        summaryRow;
        context: {label: 'Credit card fee', value: ccFee | currency: 'USD'}
      "
    ></ng-container>
  }

  <hr class="my-3" style="width: 200px; margin-left: auto" />
  <ng-container
    *ngTemplateOutlet="summaryRow; context: {label: 'Total', value: total | currency: 'USD'}"
  ></ng-container>
</div>

<ng-template #summaryRow let-label="label" let-value="value">
  <span class="flex justify-content-end align-items-center mr-1 font-semibold">
    {{ label }}: {{ value }}
  </span>
</ng-template>
